/*
 * Copyright 2012 Sagarana Tech.  All rigths reserved.
 *
 * This software is the confidential and proprietary information of
 * Sagarana Tech ("Confidential Information"). You shall not disclose such
 * Confidential Information and shall use it only in accordance with the
 * terms of the license agreement you entered into with Sagarana Tech.
 *
 */

/**
 * Implementa as ações que podem ser adicionadas ao Grid.
 * Por ação entenda as várias funções que seriam inseridas no espaço à direita do campo de
 * busca e mudanças no comportamento da grid.
 *
 * @author Mozart Diniz
 * Date: 20/02/2013
 * Time: 10:00
 */

/**
 * Inicializa todos os módulos.
 *
 * @param {string} selector: É a query de indica onde o grid está na tela, normalmente o ID da
 * entidade ou um padrão que concatena o nome da tela com o ID do dados trabalhado.
 *
 * @param {array} actions: Lista com todos os actions que serão inicializados, os actions
 * possíveis atualmente são: CUSTOMIZE_COLUMNS, DELETE_ITEM
 *
 * Exemplo de uso:
 *
 * var actions = new Monet.FormBuilder.GridActions("#Entity", [
 *  "CUSTOMIZE_COLUMNS", "DELETE_ITEM"
 * ]);
 *
 */


Monet.Grid = Monet.Grid || {};
Monet.Grid.Actions = Monet.Grid.Actions || {};

Monet.Grid.Actions = function () {

    this.setEntity = function (entity) {
        this.entity = entity;
        this.selector = "#" + this.entity;
    };

    this.setEntityToActionGrid = function(entityToActionGrid) {
        this.entityToActionGrid = entityToActionGrid;
    };

    this.setElement = function (query) {
        this.element = document.querySelector(query);

        this.el = document.createElement("div");
        this.el.setAttribute('class', "MonetUIGridActions");
        this.element.appendChild( this.el );

    };

    this.setFieldsOverride = function (fieldsOverride){
        this.fieldsOverride = fieldsOverride;
    };

    this.setActions = function (actions) {
        this.actions = actions;
    };

    this.setScreenName = function (screenName) {
        this.screenName = screenName;
    };

    this.setGridSelector = function (selector) {
        this.gridSelector = selector;
    };

    this.createNamespace = function(key, object) {
        App.Forms[this.entity] = App.Forms[this.entity] || {};

        if( !App.Forms[this.entity]["actions"] ) {
            App.Forms[this.entity]["actions"] = {};
        }
        App.Forms[this.entity].actions[key] = object;
    };

    this.addCustomizeColumns = function () {

        var customizecolumns = new Monet.Grid.ActionsModules.CustomizeColumns();

        customizecolumns.setEntity(this.entityToActionGrid || this.entity);
        customizecolumns.setCustomNamespace(this.entity);
        customizecolumns.setSelector(this.gridSelector || this.selector);
        customizecolumns.setElement(this.el);
        customizecolumns.setScreenName(this.screenName || this.customNameSpace || this.entity);
        customizecolumns.init();

        this.createNamespace("customizecolumns", customizecolumns);

    };

    this.addFieldsAndExportFormats = function () {

        var exportFormats = new Monet.Grid.ActionsModules.ExportFormats();

        exportFormats.setEntity(this.entity);
        exportFormats.setSelector(this.selector);
        exportFormats.setElement(this.el);
        exportFormats.setScreenName(this.screenName);

        exportFormats.init();
        this.createNamespace("exportFormats", exportFormats);

    };

    this.addFilterGrid = function () {

        var filterGrid = new Monet.Grid.ActionsModules.FilterGrid();

        filterGrid.setEntity(this.entity);
        filterGrid.setSelector(this.selector);
        filterGrid.setElement(this.el);
        filterGrid.setScreenName(this.screenName);

        filterGrid.init();

    };

    this.addCustomFilters = function () {

        var filterBuilder = new Monet.Grid.ActionsModules.CustomFilters();

        filterBuilder.setEntity (this.entityToActionGrid || this.entity);
        filterBuilder.setGridSelector (this.gridSelector);
        filterBuilder.setCustomNameSpace (this.entity);
        filterBuilder.setElement(this.element);
        filterBuilder.setFieldsOverride(this.fieldsOverride);

        filterBuilder.init();

    };

    this.addSaveLayout = function () {

        var saveLayout = new Monet.Grid.ActionsModules.SaveGridLayout();

        saveLayout.setEntity(this.entity);
        saveLayout.setSelector(this.gridSelector || this.selector);
        saveLayout.setElement(this.el);
        saveLayout.setScreenName(this.screenName);

        saveLayout.init();

    };

    this.addHelpButton = function () {
        const gridContainer = document.querySelector(`${this.selector} .MonetUIGridActions`);
        const btnContainer = document.createElement('div');
        const link = document.createElement("a");

        const helpResource = Monet.I18n.getResourcesByKey('greenmile.grid.button.helppage');

        btnContainer.classList.add("MonetUIHelp");

        link.setAttribute("title", helpResource);
        link.setAttribute("href", "https://greenmile.help.descartesservices.com");
        link.setAttribute("target", "_blank");
        link.classList.add("MonetUIHelpLink")

        btnContainer.appendChild(link);

        if(gridContainer) {
            gridContainer.insertBefore(btnContainer, gridContainer.firstChild);
        }
    };

    this.init = function () {
        if (this.actions.indexOf("CUSTOM_FILTERS") !== -1) {
            this.addCustomFilters();
        }

        if (this.actions.indexOf("EXPORT_FORMATS") !== -1) {
            this.addFieldsAndExportFormats();
        }

        if (this.actions.indexOf("CUSTOMIZE_COLUMNS") !== -1) {
            this.addCustomizeColumns();
        }

        if (this.actions.indexOf("SAVE_LAYOUT") !== -1) {
            this.addSaveLayout();
        }

        if (this.actions.indexOf("FILTER_GRID") !== -1) {
            this.addFilterGrid();
        }

        this.addHelpButton();
    };

};

/**
 * Namespace para guardar a implementação dos módulos do GRID
 *
 */


Monet.Grid = Monet.Grid || {};
Monet.Grid.ActionsModules = Monet.Grid.ActionsModules || {};

/**
 * Transforma a lista de icones de delete em checkboxes que poderão ser marcados e enviados para
 * o servidor, de maneira tal que possa ter delete em massa.
 *
 * @param {string} selector: É a query de indica onde o grid está na tela, normalmente o ID da
 * entidade ou um padrão que concatena o nome da tela com o ID do dados trabalhado.
 *
 */

Monet.Grid.ActionsModules.DeleteItem = function () {

    // a ser feito :D

};
